/** Normalize SWR / API offer list responses */
export const parseOffersList = (data) => {
  if (!data) return []
  if (Array.isArray(data)) return data
  if (Array.isArray(data.result)) return data.result
  if (Array.isArray(data.data)) return data.data
  return []
}

export const discountLabel = (offer) => {
  // If the offer targets a specific product, derive the real discount from its prices
  if (offer.target_product) {
    const base = parseFloat(offer.target_product.base_price) || 0
    const sale = parseFloat(offer.target_product.sale_price) || 0
    if (sale > 0 && sale < base) {
      const pct = Math.round(((base - sale) / base) * 100)
      return `${pct}% OFF`
    }
    return 'Special Offer'
  }
  // Fallback to offer-level discount fields
  if (offer.discount_type === 'percent' && offer.discount_value > 0) return `${offer.discount_value}% OFF`
  if (offer.discount_type === 'fixed' && offer.discount_value > 0) return `₹${offer.discount_value} OFF`
  if (offer.discount_type === 'free_shipping') return 'Free Shipping'
  if (offer.discount_type === 'bogo') return 'Buy 1 Get 1'
  return 'Special Offer'
}

export const getOfferLink = (offer) => {
  if (offer.applies_to === 'category' && offer.target_id) return `/products?category_id=${offer.target_id}`
  if (offer.applies_to === 'product' && offer.target_id) return `/products/${offer.target_id}`
  if (offer.applies_to === 'brand' && offer.target_id) return `/products?brand_id=${offer.target_id}`
  return '/products'
}

export const formatOfferDateTime = (dateStr) => {
  if (!dateStr) return null
  return new Date(dateStr).toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const getOfferCountdownTarget = (offer) => {
  if (offer.is_upcoming && offer.starts_at) {
    return { target: offer.starts_at, label: 'Starts in', dateLabel: 'Starts on' }
  }
  if (offer.ends_at) {
    return { target: offer.ends_at, label: 'Ends in', dateLabel: 'Ends on' }
  }
  return null
}
